module.exports = __webpack_public_path__ + "src/routes/home/Dashboard.png?75df687d";


//////////////////
// WEBPACK FOOTER
// ./src/routes/home/Dashboard.png
// module id = 916
// module chunks = 1